import { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";

import { CourseRouteTypeEnum, NO_VALUE_DISPLAY } from "@ryde/shared";

import { CourseIndicatorIcon } from "../../grid";
import { FramerTooltip } from "../tooltips";

interface IMapTooltipCourseRowProps {
  courseName?: string;
  /** Course's client code (e.g. TLV line number) — shown instead of Ryde's internal course id. */
  courseCode?: string;
  courseRouteType?: CourseRouteTypeEnum;
}

export const MapTooltipCourseRow: FC<IMapTooltipCourseRowProps> = ({
  courseName,
  courseCode,
  courseRouteType,
}) => {
  const { t } = useTranslation();

  const displayText = useMemo(() => {
    const name = courseName?.trim();
    const code = courseCode?.trim();
    if (name && code) {
      return `${name} (${code})`;
    }
    return name || code || NO_VALUE_DISPLAY;
  }, [courseName, courseCode]);

  const tooltipContent = useMemo(() => {
    const courseTypeTranslated = courseRouteType
      ? t(`selectListLabel.${courseRouteType}`)
      : "";
    return courseTypeTranslated
      ? `${courseTypeTranslated} | ${displayText}`
      : displayText;
  }, [courseRouteType, displayText, t]);

  return (
    <div className="detail-row detail-row--course">
      <span className="detail-row__label">
        {t("rideMap.COURSE", { defaultValue: "Course" })}
      </span>
      <FramerTooltip content={tooltipContent}>
        <span className="detail-row__value detail-row__value--course truncate-text">
          <CourseIndicatorIcon routeType={courseRouteType} />
          <span className="detail-row__course-text">{displayText}</span>
        </span>
      </FramerTooltip>
    </div>
  );
};
